/**
 * Ghi nhớ các băng lỗi việc-nền mà người dùng đã ĐÓNG — bền qua F5.
 *
 * 🔴 Vì sao cần (user báo 260806): danh sách `failures` do server trả trong cửa sổ 180 phút, còn "đã đóng" ban
 * đầu chỉ là state trong tab ⇒ bấm ✕ xong load lại là **hiện lại nguyên xi**. Băng lỗi phải đóng được thật,
 * nếu không nó thành thứ người dùng học cách phớt lờ — và lúc có lỗi thật thì không ai đọc nữa.
 *
 * Lưu theo id job + mốc thời gian để tự dọn (id cũ hơn `MAX_AGE_MS` bị bỏ, tránh localStorage phình mãi).
 * Không import antd/React ⇒ unit-test được dưới jest của react-scripts (xem CLAUDE.md).
 */
const KEY = 'film.dismissedJobs';
const MAX_AGE_MS = 48 * 3600 * 1000;

type Store = Record<string, number>; // jobId → mốc đóng (ms)

function read(): Store {
    try {
        const raw = localStorage.getItem(KEY);
        const obj = raw ? JSON.parse(raw) : {};
        return obj && typeof obj === 'object' ? obj as Store : {};
    } catch { return {}; /* private mode / JSON rác: coi như chưa đóng gì, KHÔNG để nổ cả màn */ }
}

function write(s: Store): void {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch { /* hết quota / private mode: chấp nhận quên */ }
}

/** Bỏ mốc quá cũ. Gọi lúc đọc để việc dọn không cần cron riêng. */
export function pruneDismissedJobs(now = Date.now()): Store {
    const s = read();
    let changed = false;
    for (const [id, at] of Object.entries(s)) {
        if (!Number.isFinite(at) || now - at > MAX_AGE_MS) { delete s[id]; changed = true; }
    }
    if (changed) write(s);
    return s;
}

/** Danh sách id đã đóng (đã dọn cái quá cũ). */
export const loadDismissedJobs = (now = Date.now()): string[] => Object.keys(pruneDismissedJobs(now));

/** Ghi thêm các id vừa đóng; trả về danh sách đầy đủ sau khi ghi (để set vào state). */
export function addDismissedJobs(ids: string[], now = Date.now()): string[] {
    const s = pruneDismissedJobs(now);
    ids.filter(Boolean).forEach((id) => { s[id] = now; });
    write(s);
    return Object.keys(s);
}
